import store from "../store";

export function getActiveExperiments(): string[] {
  const experimentState = store.getState().experiment;
  return experimentState ? experimentState.experiments : [];
}
